import React from "react";
import { useState } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import BankAccItemBody from "./BankAccItemBody";
import InsertCategoryModel from "./InsertCategoryModel";
import InsertRecurringExpModel from "./InsertRecurringExpModel";

const options = {
  sortIndicator: true,
  hideSizePerPage: false,
  paginationSize: 3,
  hidePageListOnlyOnePage: false,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
};

export default function RecurringExpBody({ data }) {
  const [contextMenuOpen, setContextMenuOpen] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [contextMenuPosition, setContextMenuPosition] = useState({
    x: 0,
    y: 0,
  });
  const [flag, setFlag] = useState(true);
  const [modal, setModal] = useState(false);
  const [values, setValues] = useState({
    name: "",
    type: "0",
  });

  const handleMenuItemClick = (action, row) => {
    setContextMenuOpen(false);
    if (action === 1) {
      toggle();
    }
  };

  const back = () => {
    setFlag(!flag);
  };
  const onUpdateHeadMap = ({ target }) => {
    const { name, value } = target;
    setValues((previousState) => ({
      ...previousState,
      [name]: value,
    }));
  };
  const handleRightClick = (e, row) => {
    //  e.preventDefault();
    setContextMenuPosition({ x: e.clientX, y: e.clientY });
    setContextMenuOpen(true);
    setCurrentRow(row);
  };
  const updateCategory = () => {
    //saveCategory
  };
  const cancel = () => {
    let obj = {
      name: "",
      type: "0",
    };
    setValues(obj);
    toggle();
  };

  const toggle = () => setModal(!modal);

  const cellButton = (cell, row, enumObject, rowIndex) => {
    return (
      <span>
        <Button
          className="btn btn-warning"
          id={"more" + rowIndex}
          onClick={(e) => handleRightClick(e, row)}
          style={{ marginLeft: "5px" }}
        >
          <i className="fa fa-ellipsis-v" />
        </Button>
      </span>
    );
  };
  return (
    <div>
      <Card>
        <CardHeader className="carheaderSmall">
          <strong>Recurring Entry</strong>
        </CardHeader>
        <CardBody>
          <InsertRecurringExpModel
            OnToggle={toggle}
            view={modal}
            onUpdateHeadMap={onUpdateHeadMap}
            updateCategory={updateCategory}
            cancel={cancel}
            values={values}
          />
          <BootstrapTable
            data={data}
            version="4"
            condensed={true}
            striped
            hover
            pagination
            search
            options={options}
            exportCSV
          >
            <TableHeaderColumn
              isKey
              dataField="id"
              export={false}
              hidden={true}
            >
              ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="category"
              csvHeader="category"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Category
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="amount"
              csvHeader="amount"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Amount
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="frequency"
              csvHeader="frequency"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Frequency
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="desc"
              csvHeader="Description"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Description
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="button"
              dataFormat={cellButton}
              hiddenOnInsert
              export={false}
            >
              Actions
            </TableHeaderColumn>
          </BootstrapTable>
        </CardBody>
      </Card>

      {contextMenuOpen && (
        <Dropdown
          isOpen={contextMenuOpen}
          toggle={() => setContextMenuOpen(false)}
          style={{
            position: "fixed",
            top: contextMenuPosition.y,
            left: contextMenuPosition.x,
          }}
        >
          <DropdownToggle
            tag="span"
            data-toggle="dropdown"
            aria-expanded={true}
          />
          <DropdownMenu>
            <DropdownItem onClick={() => handleMenuItemClick(1, currentRow)}>
              Create
            </DropdownItem>
            <DropdownItem onClick={() => handleMenuItemClick(2, currentRow)}>
              Add to Ledger
            </DropdownItem>
            <DropdownItem
              disabled
              onClick={() => handleMenuItemClick(3, currentRow)}
            >
              Action 3
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/RecurringExpBody.js